import { DynamicFormRequiredType } from '../../dynamic-form/dynamic-form.enums';

export interface RequiredIndicatorProps {
  readOnly?: boolean;
  required?: DynamicFormRequiredType;
}

const RequiredIndicator = ({ readOnly, required }: RequiredIndicatorProps) => {
  return readOnly === false && required === DynamicFormRequiredType.True ? (
    <span className="ml-1 text-sm text-error">*</span>
  ) : null;
};

export default RequiredIndicator;
